import { graphql } from '../../generated';

export const POLL_INVOICE_DOCUMENT_URL = graphql(`
  query PollInvoiceDocumentUrl($invoiceId: ID!) {
    invoice(id: $invoiceId) {
      documentUrl
    }
  }
`);

export const UNBOOK_INVOICE = graphql(`
  mutation UnbookInvoice($invoiceId: ID!) {
    unbookInvoice(input: { invoiceId: $invoiceId }) {
      invoice {
        id
        status
      }
    }
  }
`);
